import NotFoundRoute from "PFApp/routes/not_found_route";
import { WithLayout } from "PFApp/routes/route_helpers";
import { admin } from "PFCore/base/page_layouts";
import BookingConfigController from "PFModules/admin/booking/booking_config_controller";
import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";

const BookingConfigRoutes = () => {
  const { path } = useRouteMatch();

  return (
    <WithLayout layout={{ sidebar: admin }}>
      <Switch>
        <Route path={`${path}/:section?`}>
          <BookingConfigController />
        </Route>
        <Route path="*">
          <NotFoundRoute />
        </Route>
      </Switch>
    </WithLayout>
  );
};

export default BookingConfigRoutes;
